import { render, staticRenderFns } from "./deviceDetailManager.vue?vue&type=template&id=5b87a4eb&scoped=true&"
import script from "./deviceDetailManager.vue?vue&type=script&lang=js&"
export * from "./deviceDetailManager.vue?vue&type=script&lang=js&"
import style0 from "./deviceDetailManager.vue?vue&type=style&index=0&id=5b87a4eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b87a4eb",
  null
  
)

export default component.exports